import Type from "../Type";

const initState = {
    listPrice:[],
    arrayHuyen: [],
    arrayXa: [],
    arrayLoaiDat: [],
    arrayDuong: [],
    arrayDoan: [],
    arrayViTri: [],
    loadingSearch: false,
    huyenSelected: null,
    xaSelected: null, 
    loaiDatSelected: null,
    duongSelected:null,
    doanSelected: null,
    viTriSelected: null,
    giadat: null,
    showResult: false
   // dataTrichDoPicked:null
}

const PriceTableTerm = (state = initState,{type,route,value})=>
{
    if (type === Type.SET_PRICE_TB_TERM)
        return {
            ...state,
            [route]:value
        }
    else
        return  state;
}

export default PriceTableTerm
